import { AxiosRequestConfigMethods } from "@/api/types";
import { brandUrl, fetchFromBrandedUrl } from "@/api/utils";
import { EnvironmentVariables } from "@/modules/common/types";
import { TrackDocument, TrackDocumentType } from "../../types";
import { AxiosResponse } from "axios";

export const getPresignTrackDocuments = async ({
  documentType,
  uid,
}: {
  documentType: TrackDocumentType;
  uid?: string;
}) => {
  if (!uid) {
    return null;
  }
  const apiUrl = brandUrl<TrackDocument[]>(
    `${EnvironmentVariables.PROPERTY_MANAGEMENT_API_URL}/tracks/${uid}/presign-document-category`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
      params: {
        documentType: documentType,
      },
    },
  }) as Promise<AxiosResponse<TrackDocument[]>>;
};
